// extracted by mini-css-extract-plugin
export default {"Menu":"bgr_a bhg_h","Menu__offsetParent":"bgr_b bhg_bj","Menu__trigger--shadowed":"bgr_c"};